import { SysUiWindow } from '../../components/window';
import html2canvas from 'html2canvas';

export class SysUiWindowManager {
  private static instance: SysUiWindowManager;
  private windows: Map<string, SysUiWindow> = new Map();
  private windowCounter: number = 0;

  private constructor() {}

  static getInstance(): SysUiWindowManager {
    if (!SysUiWindowManager.instance) {
      SysUiWindowManager.instance = new SysUiWindowManager();
    }
    return SysUiWindowManager.instance;
  }

  // 注册窗口
  registerWindow(window: SysUiWindow): string {
    const windowId = `window_${this.windowCounter++}`;
    this.windows.set(windowId, window);
    return windowId;
  }

  // 注销窗口
  unregisterWindow(windowId: string): void {
    this.windows.delete(windowId);
  }

  // 获取窗口
  getWindow(windowId: string): SysUiWindow | undefined {
    return this.windows.get(windowId);
  }

  // 获取所有窗口
  getAllWindows(): SysUiWindow[] {
    return Array.from(this.windows.values());
  }

  // 获取窗口数量
  getWindowCount(): number {
    return this.windows.size;
  }

  // 关闭所有窗口
  closeAllWindows(): void {
    this.windows.forEach(window => {
      window.close();
    });
    this.windows.clear();
  }

  // 最小化所有窗口
  minimizeAllWindows(): void {
    this.windows.forEach(window => {
      window.minimize();
    });
  }

  // 查找特定类名的窗口
  findWindowsByClassName(className: string): SysUiWindow[] {
    return this.getAllWindows().filter(window =>
      window.getElement().classList.contains(className)
    );
  }

  // 置顶所有窗口到前台
  bringAllToFront(): void {
    this.windows.forEach(window => {
      window.focus();
    });
  }

  // 获取窗口截图
  async captureWindowScreenshot(windowId: string): Promise<string | null> {
    const window = this.getWindow(windowId);
    if (!window) {
      return null;
    }

    try {
      const element = window.getElement();

      // 检查元素是否可见
      if (!element || element.offsetWidth === 0 || element.offsetHeight === 0) {
        return null;
      }

      // 使用 html2canvas 库来截图
      const canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: false,
        background: undefined,
        logging: false
      });
      return canvas.toDataURL('image/png');
    } catch (error) {
      console.error('Failed to capture window screenshot:', error);
      return null;
    }
  }

  // 获取所有窗口的截图
  async captureAllWindowScreenshots(): Promise<Map<string, string>> {
    const screenshots = new Map<string, string>();

    for (const [windowId] of this.windows) {
      const screenshot = await this.captureWindowScreenshot(windowId);
      if (screenshot) {
        screenshots.set(windowId, screenshot);
      }
    }

    return screenshots;
  }

}

// 导出单例实例
export const windowManager = SysUiWindowManager.getInstance();
